import * as React from "react"
const DeleteReport = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill= {props.color || "currentColor"}
      fillOpacity={1}
      d="M7.02.416c.29 0 .557 0 .78.02.239.02.483.07.727.196.092.048.18.102.264.164.22.164.37.364.493.57.116.192.232.432.359.693l.193.399h2.414a.75.75 0 0 1 0 1.5h-.17l-.318 5.145c-.046.732-.082 1.335-.159 1.819-.078.496-.21.943-.488 1.342-.244.35-.56.646-.925.869-.415.253-.868.356-1.369.404-.488.047-1.091.046-1.825.046-.735 0-1.34.001-1.828-.046-.501-.048-.955-.152-1.371-.405a3.082 3.082 0 0 1-.925-.871c-.278-.4-.41-.847-.487-1.344-.076-.485-.111-1.088-.156-1.821l-.31-5.138H1.75a.75.75 0 0 1 0-1.5h2.465l.153-.337a9.38 9.38 0 0 1 .35-.719c.122-.212.27-.42.494-.59.084-.065.173-.122.267-.171.248-.132.498-.182.742-.204.229-.021.502-.021.8-.021ZM3.423 3.958l.305 5.047c.046.763.078 1.282.14 1.68.06.385.14.581.237.72.125.18.287.332.474.447.144.087.345.155.734.192.4.038.92.039 1.684.039.763 0 1.282 0 1.682-.04.388-.036.588-.104.732-.191.188-.115.35-.267.475-.447.096-.138.176-.334.237-.718.063-.397.096-.916.143-1.677l.312-5.052H3.422ZM7.02 1.916c-.325 0-.519 0-.665.014-.13.012-.165.03-.173.035a.417.417 0 0 0-.058.037c-.008.006-.038.03-.104.144-.045.079-.093.178-.156.312h2.302c-.07-.14-.12-.241-.169-.321a.466.466 0 0 0-.103-.138.422.422 0 0 0-.058-.036.464.464 0 0 0-.17-.033 8.168 8.168 0 0 0-.646-.014Z"
    />
    <path
      stroke= {props.color || "currentColor"}
      strokeLinecap="round"
      strokeOpacity={1}
      strokeWidth={1.5}
      d="M5.542 9.625v-3.5M8.458 9.625v-3.5"
    />
  </svg>
)
export default DeleteReport
